import { render, staticRenderFns } from "./PremiumVideo.vue?vue&type=template&id=4caedb57&"
import script from "./PremiumVideo.vue?vue&type=script&lang=js&"
export * from "./PremiumVideo.vue?vue&type=script&lang=js&"
import style0 from "./PremiumVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports